<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Criando <strong>Certificado</strong></h4>

    <div v-if="item && !blobPDF">
      <div class="row">
        <div class="col-md-8">
          <div class="pdfContent">
            <div class="internal">
              <h2>{{ item.name }}</h2>
              <p><strong>{{ showInfoStudent }}</strong></p>
              <p>{{ textDocumentSelected }}</p>
              <p>Código de validação: {{ code }}</p>
              <p>{{ createdAtText }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="accordion" id="accordion">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-front"
                  aria-expanded="true"
                  aria-controls="collapse-front"
                >
                  Configurações frente
                </button>
              </h2>
              <div
                id="collapse-front"
                class="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#accordion"
              >
                <div class="accordion-body">
                  <label>Matrícula(s):</label>
                  <select
                    v-model="registration"
                    class="form-control form-control-sm mb-2"
                    @change="verifyExistsCertificate"
                  >
                    <option value="" selected disabled>-- Selecione --</option>
                    <option
                      v-for="(opt, index) in hasRegistration"
                      :key="index"
                      :value="opt"
                    >
                      {{ String(opt.id).padStart(6, "0") }} | {{ opt.team.name }}
                    </option>
                  </select>

                  <label>Modelo de documento:</label>
                  <select
                    v-model="selectedTemplateId"
                    class="form-control form-control-sm mb-2"
                  >
                    <option value="" selected disabled>-- Selecione --</option>
                    <option
                      v-for="(tpl, index) in documentTemplates"
                      :key="index"
                      :value="tpl.id"
                    >
                      {{ tpl.name }}
                    </option>
                  </select>

                  <label>Texto do documento:</label>
                  <select
                    class="form-control form-control-sm"
                    @change="handlerSelectText"
                  >
                    <option value="" selected disabled>-- Selecione --</option>
                    <option
                      v-for="(opt, index) in textDocuments"
                      :key="index"
                      :value="opt.id"
                    >
                      {{ opt.name }}
                    </option>
                  </select>

                  <hr />

                  <label>Editar texto do documento:</label>
                  <textarea
                    cols="30"
                    rows="6"
                    class="form-control form-control-sm mt-2"
                    v-model="textDocumentSelected"
                  ></textarea>

                  <label class="mt-2">Título do documento:</label>
                  <select
                    v-model="documentTitle"
                    class="form-control form-control-sm mt-2"
                  >
                    <option value="Certificado">Certificado</option>
                    <option value="Diploma">Diploma</option>
                    <option value="__outro__">Outro...</option>
                    <option value="">— Sem título —</option>
                  </select>
                  <input
                    v-if="documentTitle === '__outro__'"
                    type="text"
                    class="form-control form-control-sm mt-2"
                    placeholder="Digite o título"
                    v-model="documentTitleCustom"
                  />

                  <label class="text-danger mt-2">Código validador:</label>
                  <input
                    type="text"
                    class="form-control form-control-sm mt-2"
                    v-model="code"
                  />

                  <label class="mt-2">Data da emissão:</label>
                  <input
                    type="date"
                    class="form-control form-control-sm mt-2"
                    v-model="documentDate"
                  />

                  <div class="form-check mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="chkWithBackground"
                      v-model="withBackground"
                    />
                    <label class="form-check-label" for="chkWithBackground">
                      Imprimir com fundo
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingVerso">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-verso"
                  aria-expanded="false"
                  aria-controls="collapse-verso"
                >
                  Configurações verso
                </button>
              </h2>
              <div
                id="collapse-verso"
                class="accordion-collapse collapse"
                aria-labelledby="headingVerso"
                data-bs-parent="#accordion"
              >
                <div class="accordion-body">
                  <label><strong>Linha 1 (livro emitido):</strong></label>
                  <textarea
                    cols="30"
                    rows="4"
                    class="form-control form-control-sm mt-1"
                    placeholder="Certificado Registrado sob nº ..."
                    v-model="backLine1"
                  ></textarea>                

                  <label class="mt-2"><strong>Linha 2 (observações):</strong></label>
                  <textarea
                    cols="30"
                    rows="4"
                    class="form-control form-control-sm mt-1"
                    placeholder="Deixe em branco se não desejar texto de observação no verso."
                    v-model="freeText"
                  ></textarea>

                  <div class="form-check mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="chkShowSistec"
                      v-model="showSistec"
                    />
                    <label class="form-check-label" for="chkShowSistec">
                      Exibir SISTEC/MEC
                    </label>
                  </div>
                  <hr />
                  <label class="mt-2"><strong>Texto para o verso de CURSOS LIVRES:</strong></label>
                  <textarea
                    cols="30"
                    rows="4"
                    class="form-control form-control-sm mt-1"
                    placeholder="Ex.: CONTEÚDO:
BIOSSEGURANÇA.
PUNÇÃO VENOSA COM ESCALPE(SCALP).
INJEÇÃO INTRAMUSCULAR(IN)."
                    v-model="textoCursosLivres"
                  ></textarea>

                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12 text-center">
              <button
                v-if="!blobPDF"
                @click="makePDF"
                :disabled="loading"
                class="btn btn-success btn-sm text-uppercase"
              >
                <span v-if="loading">Gerando...</span>
                <span v-else>Gerar PDF</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LoadingPage v-if="loading && !blobPDF" />

    <iframe
      v-if="blobPDF"
      :src="blobPDF"
      width="100%"
      height="680"
      style="border: none"
    ></iframe>

    <button
      v-if="blobPDF"
      @click="destroyPDF"
      class="btn btn-sm text-uppercase btn-danger me-2"
    >
      Apagar Certificado
    </button>

    <button
      class="btn btn-sm text-uppercase btn-secondary"
      @click="$router.go(-1)"
    >
      VOLTAR
    </button>
  </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import { generateHash, displayDateInFull, cpfWithMask, documentStorageUrl } from "@/helpers";

export default {
  name: "CertificateRegister",
  props: ["student"],
  components: { LoadingPage },
  data() {
    return {
      folder: "certificate",
      textDocuments: [],
      documentTemplates: [],
      blobPDF: null,
      loading: false,
      item: null,
      code: "",
      typeDocument: "CERTIFICATE",
      attachments: [],
      documentTitle: "Certificado",
      documentTitleCustom: "",
      withBackground: true,
      freeText: "",
      textoCursosLivres: "",
      documentDate: "",
      backLine1: "",
      showSistec: true,
      textDocumentSelected: "",
      selectedTemplateId: "",
      hasRegistration: [],
      registration: "",
      generatedFilePath: "",
      generateHash,
      displayDateInFull,
      cpfWithMask,
    };
  },
  computed: {
    showInfoStudent() {
      if (!this.item) return "";
      return `${this.item.nationality}, natural de ${this.item.naturalness}, nascido(a) em ${this.displayDateInFull(this.item.birth_date)}, CPF ${cpfWithMask(this.item.cpf)},`;
    },
    createdAtText() {
      const now = new Date();
      const date = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}`;
      return `Ananindeua - Pará, ${this.displayDateInFull(date)}`;
    },
    fileFound() {
      if (!this.generatedFilePath) return "";
      const parts = this.generatedFilePath.split("/");
      return parts[parts.length - 1];
    },
  },
  methods: {
    getFullYear() {
      return new Date().getFullYear();
    },
    verifyExistsCertificate() {
      this.getItem();
      this.fetchBookData();
    },
    async fetchBookData() {
      if (!this.registration || !this.registration.team_id) return;
      try {
        const res = await api.get(
          `/books?student_id=${this.item.id}&team_id=${this.registration.team_id}`
        );
        const book = (res.data.data || [])[0];
        if (book) {
          const today = new Date();
          const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
          
          this.backLine1 =
            `Certificado Registrado sob nº ${book.registration_number}\n` +
            `No Livro nº ${book.book_number} Folha nº ${book.page_number}\n` +
            // `Em ${book.issue_date}\n` +
            `Em ${this.displayDateInFull(formattedDate)}.`;
        }
      } catch (_) {
        // sem livro cadastrado, mantém campo em branco
      }
    },
    handlerSelectText(ev) {
      const idText = ev.target.value;
      const text = this.textDocuments.find((e) => e.id == idText);
      if (!text) return;

      const now = new Date();
      const tokens = {
        "[[DATA_ANO]]": now.getFullYear(),
        "[[DATA_MES]]": String(now.getMonth() + 1).padStart(2, "0"),
        "[[DATA_DIA]]": String(now.getDate()).padStart(2, "0"),
        "[[NOME_ALUNO]]": this.item?.name ?? "",
        "[[CPF_ALUNO]]": this.item ? cpfWithMask(this.item.cpf) : "",
        "[[DATA_NASCIMENTO]]": this.item ? this.displayDateInFull(this.item.birth_date) : "",
        "[[TURMA]]": this.registration?.team?.name ?? "",
        "[[NATURALIDADE]]": this.item?.naturalness ?? "",
        "[[NACIONALIDADE]]": this.item?.nationality ?? "",
      };

      this.textDocumentSelected = Object.entries(tokens).reduce(
        (content, [token, value]) =>
          content.replace(new RegExp(token.replace(/[\[\]]/g, "\\$&"), "g"), value),
        text.content
      );
    },
    async getTextDocuments() {
      await api.get("/text-documents").then((res) => {
        this.textDocuments = res.data.data;
      });
    },
    async getDocumentTemplates() {
      await api.get("/document-templates?perPage=100").then((res) => {
        this.documentTemplates = (res.data.data || []).filter(
          (t) => t.active && /frente/i.test(t.name)
        );
      });
    },
    async getItem() {
      await api.get(`/students/${this.student}`).then((res) => {
        this.attachments = res.data[0].documents.filter(
          (e) => e.type === this.typeDocument
        );
        this.item = res.data[0];
        this.hasRegistration = res.data[0].registrations;
      });
    },
    destroyPDF() {
      api
        .get(`/documents/${this.folder}/${this.fileFound}/remove`)
        .then((response) => {
          this.blobPDF = null;
          this.generatedFilePath = "";
          Toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          Toast.fire(error.response.data.message, "", "error");
        });
    },
    async makePDF() {
      if (!this.registration || !this.selectedTemplateId) {
        return Toast.fire(
          "Erro",
          "Selecione a matrícula e o modelo do documento.",
          "error"
        );
      }

      if (!this.textDocumentSelected) {
        return Toast.fire(
          "Erro",
          "Selecione ou preencha o texto do documento.",
          "error"
        );
      }

      this.loading = true;

      try {
        const payload = {
          student_id: this.item.id,
          team_id: this.registration.team_id,
          template_id: this.selectedTemplateId,
          extra: {
            textDocument: this.textDocumentSelected,
            documentTitle: this.documentTitle === '__outro__'
              ? this.documentTitleCustom
              : this.documentTitle,
            withBackground: this.withBackground,
            freeText: this.freeText,
            textoCursosLivres: this.textoCursosLivres || null,
            documentDate: this.documentDate || null,
            backLine1: this.backLine1 || null,
            showSistec: this.showSistec,
          },
        };

        const response = await api.post("/exports/generate-document", payload);
        const { folder, file_name } = response.data.data;

        await this.loadPDF(folder, file_name);

        Toast.fire("Sucesso", "Certificado gerado!", "success");
      } catch (error) {
        const message =
          error.response?.data?.message || "Erro ao gerar o certificado.";
        Toast.fire("Erro", message, "error");
      } finally {
        this.loading = false;
      }
    },
    async loadPDF(folder, fileName) {
      await api
        .get(documentStorageUrl(folder, fileName), {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.blobPDF = URL.createObjectURL(blob);
          this.generatedFilePath = `${folder}/${fileName}`;
        });
    },
  },
  mounted() {
    this.code = this.generateHash("CERT_");
    const today = new Date();
    this.documentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    this.getItem();
    this.getTextDocuments();
    this.getDocumentTemplates();
  },
};
</script>

<style scoped>
.pdfContent {
  margin: 0 auto;
  width: 100%;
  height: calc(100vh - 10vh);
  border: 1px dashed #999;
  display: flex;
  align-items: center;
  padding: 0 60px;
  max-height: 500px;
  background-color: #eee;
}

.pdfContent .internal {
  text-align: center;
}
</style>
